import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Careers from "./pages/Careers";
import CareersRole from "./pages/CareersRole";
import Farms from "./pages/Farms";
// tokens.css and base.css are imported in index.js, ahead of this module, so
// component stylesheets cascade over them rather than under them.

/* Converts legacy `#/labs` hash URLs to clean paths. */
function HashRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.hash.startsWith("#/")) {
      navigate(location.hash.slice(1), { replace: true });
    }
  }, [location.hash, navigate]);

  return null;
}

/*
 * Router-aware scroll behavior.
 *
 * A plain <a href="#process"> would work, but router <Link>s push state without
 * the browser's native anchor handling, so section links from /blog back to
 * /#process would land at the top of the page. This restores both halves:
 * scroll to the target when there's a hash, scroll to top when there isn't.
 */
function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash && !hash.startsWith("#/")) {
      // Wait a frame so the destination route has mounted its sections.
      const id = hash.slice(1);
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <HashRedirect />
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/labs" element={<Navigate to="/" replace />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/careers/:slug" element={<CareersRole />} />
        <Route path="/farms" element={<Farms />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
